import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../views/HomePage.vue";
import OpticalExperiment from "../views/OpticalExperiment.vue";
import PendulumExperiment from "../views/PendulumExperiment.vue";
import NutonExperiment from "../views/NutonExperiment.vue";
import ThermodynamicsExperiment from "../views/ThermodynamicsExperiment.vue";
import ObjectLens from "@/views/ObjectLens.vue";
import CollisionSimulator from "@/views/CollisionSimulator.vue";
import CircuitBoard from "@/views/CircuitBoard.vue";
import PendulumArduino from "@/views/PendulumArduino.vue"; 
import Mpu6050Graph from "@/views/Mpu6050Graph.vue"; 
import PixelGame from "@/views/PixelGame.vue";
import FizikQuest from "@/views/FizikQuest.vue";
import NotFound from "@/views/NotFound.vue";
import QuestPage from "@/views/QuestPage.vue";
import ExperimentPage from "@/views/ExperimentPage.vue";
import InformatikQuest from "@/views/InformatikQuest.vue";
import QrScanner from "@/views/QrScanner.vue";
import QrQuest from "@/views/QrQuest.vue";
import ThreeDmodels from "@/views/ThreeDmodels.vue"
import BuffonSimulation from "../views/BuffonSimulation.vue"
import ScheduleSearch from "@/views/ScheduleSearch.vue";






const routes = [
  {
    path: "/",
    name: "HomePage",
    component: HomePage,
    meta: {
      title: "Главная - Лабораторные работы",
      description: "Добро пожаловать в раздел лабораторных работ по физике.",
    },
  },
  {
    // сохраняем encodeURI, добавляем alias (декодированный путь)
    path: encodeURI("/оптический-эксперимент"),
    alias: "/оптический-эксперимент",
    name: "OpticalExperiment",
    component: OpticalExperiment,
    meta: {
      title: "Оптический эксперимент",
      description: "Исследование оптических свойств линз в эксперименте.",
    },
  },
  {
    path: encodeURI("/движение-маятника"),
    alias: "/движение-маятника",
    name: "PendulumExperiment",
    component: PendulumExperiment,
    meta: {
      title: "Маятник",
      description: "Изучение движения маятника и его параметров.",
    },
  },
  {
    path: encodeURI("/законы-ньютона"),
    alias: "/законы-ньютона",
    name: "NutonExperiment",
    component: NutonExperiment,
    meta: {
      title: "Законы Ньютона",
      description: "Симуляция и визуализация законов Ньютона.",
    },
  },
  {
    path: encodeURI("/закон-термодинамики"),
    alias: "/закон-термодинамики",
    name: "ThermodynamicsExperiment",
    component: ThermodynamicsExperiment,
    meta: {
      title: "Законы термодинамики",
      description: "Анализ термодинамических процессов: температура, давление, объём.",
    },
  },
  {
    path: encodeURI("/построение-изображения-в-линзе"),
    alias: "/построение-изображения-в-линзе",
    name: "ObjectLens",
    component: ObjectLens,
    meta: {
      title: "Построение изображения в линзе",
      description: "Визуализация построения изображения в собирающей линзе.",
    },
  },
  {
    path: encodeURI("/Столкновение-двух-тел"),
    alias: "/Столкновение-двух-тел",
    name: "CollisionSimulator",
    component: CollisionSimulator ,
    meta: {
      title: "Плоское столкновение двух тел",
      description: "Изучить закон сохранения импульса при упругом и неупругом столкновении.",
    },
  },
  {
    path: encodeURI("/электрическая-схема"),
    alias: "/электрическая-схема",
    name: "CircuitBoard",
    component: CircuitBoard,
    meta: {
      title: "Электрическая схема: компоненты и принципы работы",
      description: "Полное руководство по электрическим схемам, их компонентам и принципам работы. Изучение основ построения и анализа электрических цепей.",
      suggestedKeywords: "электрическая схема, электронные компоненты, электрические цепи, принципы работы схем, построение схем, анализ электрических цепей, электронные устройства, электрические символы, электронные компоненты, электрическая цепь",
      og: {
        ogTitle: "Электрическая схема: компоненты и принципы работы",
        ogDescription: "Полное руководство по электрическим схемам, их компонентам и принципам работы. Изучение основ построения и анализа электрических цепей.",
        ogImage: "/images/electric-scheme.jpg",
        ogType: "website"
      },
      twitter: {
        twitterTitle: "Электрическая схема: компоненты и принципы работы",
        twitterDescription: "Полное руководство по электрическим схемам, их компонентам и принципам работы. Изучение основ построения и анализа электрических цепей.",
        twitterImage: "/images/electric-scheme.jpg"
      }
    }
  },
  //Ардуино
  {
    path: encodeURI("/маятник-ардуино"),
    alias: "/маятник-ардуино",
    name: "PendulumArduino",
    component: PendulumArduino,
    meta: {
        title: "Исследование маятника с помощью Arduino",
        description: "Подробное руководство по созданию и изучению движения маятника с использованием платформы Arduino. Описание эксперимента, схемы подключения и программного кода.",
        suggestedKeywords: "Arduino, маятник, физика, эксперимент, датчики, обработка данных, программирование, электроника, механика, колебательные движения",
        og: {
            ogTitle: "Исследование маятника с помощью Arduino",
            ogDescription: "Подробное руководство по созданию и изучению движения маятника с использованием платформы Arduino. Описание эксперимента, схемы подключения и программного кода.",
            ogImage: "/images/arduino-pendulum.jpg",
            ogType: "website"
        },
        twitter: {
            twitterTitle: "Исследование маятника с помощью Arduino",
            twitterDescription: "Подробное руководство по созданию и изучению движения маятника с использованием платформы Arduino. Описание эксперимента, схемы подключения и программного кода.",
            twitterImage: "/images/arduino-pendulum.jpg"
        }
    }
},

{
  path: encodeURI("/физический-пазл"),
  alias: "/физический-пазл",
  name: "PixelGame",
  component: PixelGame,
  meta: {
    title: "Физический пазл",
    description: "Изучение физических явлений с помощью пазла.",
  },  
},

 {
    path: encodeURI("/маятник-график"),
    alias: "/маятник-график",
    name: "Mpu6050Graph",
    component: Mpu6050Graph,
    meta: {
        title: "Исследование маятника с помощью ESP32 и MPU6050",
        description: "Подробное руководство по созданию и изучению движения маятника с использованием платформы ESP32 и датчика MPU6050. Описание эксперимента, схемы подключения и программного кода.",
        suggestedKeywords: "ESP32, MPU6050, маятник, физика, эксперимент, датчики, обработка данных, программирование, электроника, механика, колебательные движения",
        og: {
            ogTitle: "Исследование маятника с помощью ESP32 и MPU6050",
            ogDescription: "Подробное руководство по созданию и изучению движения маятника с использованием платформы ESP32 и датчика MPU6050. Описание эксперимента, схемы подключения и программного кода.",
            ogImage: "/images/esp32-mpu6050.jpg",
            ogType: "website"
        },
        twitter: {
            twitterTitle: "Исследование маятника с помощью ESP32 и MPU6050",
            twitterDescription: "Подробное руководство по созданию и изучению движения маятника с использованием платформы ESP32 и датчика MPU6050. Описание эксперимента, схемы подключения и программного кода.",
            twitterImage: "/images/esp32-mpu6050.jpg"
        }
    }
},

{
  path: encodeURI("/квест-по-физике"),
  alias: "/квест-по-физике",
  name: "FizikQuest",
  component: FizikQuest,
  meta: {
    title: "Квест по физике",
    description: "Интерактивный квест по физике с задачами и экспериментами.",
  },
},

{
  path: encodeURI("/квест-по-информатике"),
  alias: "/квест-по-информатике",
  name: "InformatikQuest",
  component: InformatikQuest,
  meta: {
    title: "Квест по информатике",
    description: "Интерактивный квест по информатике с задачами и экспериментами.",
  },
},



{
  path: encodeURI("/квесты"),
  alias: "/квесты",
  name: "QuestPage",
  component: QuestPage,
  meta: {
    title: "Квесты по физике",
    description: "Список квестов по физике с задачами и экспериментами.",
  },
},

{
  path: encodeURI("/эксперименты"),
  alias: "/эксперименты",
  name: "ExperimentPage",
  component: ExperimentPage,
  meta: {
    title: "Эксперименты по физике",
    description: "Список экспериментов по физике с интерактивными симуляциями.",
  },
},

{
  path: encodeURI("/qr-квест"),
  alias: "/qr-квест",
  name: "QrScanner",
  component: QrScanner,
  meta: {
    title: "QR-квест",
    description: "Квест с использованием QR-кодов для поиска информации и выполнения заданий.",
  },
},


{
  path: encodeURI("/3д"),
  alias: "/3д",
  name: "ThreeDmodels",
  component: ThreeDmodels,
  meta: {
    title: "3д модели",
    description: "3д модели.",
  },
},


{
  path: encodeURI("/квест-по-педагогике"),
  alias: "/квест-по-педагогике",
  name: "QrQuest",
  component: QrQuest,
  meta: {
    title: "Квест по педагогике",
    description: "Интерактивный квест по педагогике с задачами и экспериментами.",
  },
},


{
  path: encodeURI("/число-пи"),
  alias: "/число-пи",
  name: "BuffonSimulation",
  component: BuffonSimulation,
  meta: {
    title: "Число Пи",
    description: "Поиск числа ПИ.",
  },
},


{
  path: encodeURI("/журнал"),
  alias: "/журнал",
  name: "ScheduleSearch",
  component: ScheduleSearch,
  meta: {
    title: "Журнал нагрузки",
    description: "Поиск рабочих дней.",
  },
},



// Маршрут для отдачи статических файлов из папки /public/quest
{
  path: '/quest/:pathMatch(.*)*',
  beforeEnter() {
    // Отдаём управление статическим файлам
    window.location.href = '/quest/' + window.location.pathname.split('/quest/')[1];
  }
},


  // Добавляем маршрут для страницы 404
  {
    path: "/404",
    name: "NotFound",
    component: NotFound,
    meta: {
      title: "Страница не найдена",
      description: "К сожалению, запрашиваемая страница не найдена.",
    },
  },

  // Перенаправление на страницу 404 для всех несуществующих маршрутов
  {
    path: "/:catchAll(.*)*",
    redirect: "/404",
  },
];


const router = createRouter({
  // использовать import.meta.env.BASE_URL когда доступно (Vite), иначе fallback
  history: createWebHistory(import.meta?.env?.BASE_URL || process.env.BASE_URL || "/"),
  routes,
});

export default router;
